import { render, staticRenderFns } from "./LimitManagement.vue?vue&type=template&id=01b88378&scoped=true"
import script from "./LimitManagement.vue?vue&type=script&lang=js"
export * from "./LimitManagement.vue?vue&type=script&lang=js"
import style0 from "./LimitManagement.vue?vue&type=style&index=0&id=01b88378&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b88378",
  null
  
)

export default component.exports